import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { applicationsApi } from 'api/applications';
import { ApplicationForListingDto } from 'pages/ApplicationsListingPage/ApplicationsTable/types';

export const useAnalystApplications = (): UseQueryResult<ApplicationForListingDto[]> =>
  useQuery(['analystApplications'], () => applicationsApi.getAnalystAll());
